import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Amber note under a setting that can block real visitors or silently do nothing.
export default function SettingWarning({ children, testId }) {
  if (!children) return null;
  return (
    <div
      role="note"
      data-testid={testId || 'setting-warning'}
      className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 p-2 text-xs text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
